<template>
  <div class="setting-page">
    <div class="panel">
      <div class="title">审计数据</div>
      <p class="tip">符合 GB/T 24589.1—2024《财经信息技术 会计核算软件数据接口 第1部分：企业》标准。</p>
      <div class="form-row">
        <Select v-model="year" :datas="years" placeholder="选择年份" style="width:160px"></Select>
        <Button color="primary" @click="exportData">导出审计数据</Button>
      </div>
      <div class="desc">
        <p>导出内容说明：</p>
        <ul>
          <li><b>U01 总账数据</b>：会计科目、科目余额及发生额、记账凭证分录、现金流量数据</li>
          <li><b>U02 固定资产</b>：资产卡片、折旧记录、资产类别及变动情况（已启用时导出）</li>
          <li><b>U04 员工薪酬</b>：薪酬期间、薪酬项目、员工薪酬记录及明细（已启用时导出）</li>
          <li><b>U05 使用说明</b>：导出文件为 ZIP 格式，XML 格式符合标准 Schema 规范</li>
        </ul>
        <p class="note">日期格式采用 yyyy-MM-dd，金额保留2位小数，数量/汇率保留8位小数。</p>
      </div>
    </div>

    <div class="panel">
      <Table :datas="datas" stripe>
        <TableItem title="年份" prop="year"></TableItem>
        <TableItem title="导出时间" prop="exportTime"></TableItem>
        <TableItem title="操作员" prop="operator"></TableItem>
        <TableItem title="文件大小" prop="fileSize"></TableItem>
        <TableItem title="操作" :width="120">
          <template slot-scope="{ data }">
            <Button text-color="primary" size="xs" @click="download(data)">下载</Button>
          </template>
        </TableItem>
      </Table>
      <Pagination v-model="pagination" @change="loadData" layout="pager" small align="center" v-if="datas.length" />
      <p v-if="!datas.length" class="empty">暂无导出记录</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditExportIndex',
  data() {
    return {
      year: new Date().getFullYear(),
      years: [],
      datas: [],
      pagination: { page: 1, size: 10, total: 0 }
    };
  },
  mounted() {
    this.loadYears();
    this.loadData();
  },
  methods: {
    loadYears() {
      this.$api.setting.auditExport.years().then((res) => {
        this.years = res.data || [];
        if (this.years.length && !this.years.includes(this.year)) {
          this.year = this.years[0];
        }
      });
    },
    loadData() {
      const p = { page: this.pagination.page, pageSize: this.pagination.size, year: this.year };
      this.$api.setting.auditExport.page(p).then((res) => {
        this.datas = res.data.records || [];
        this.pagination.total = res.data.total || 0;
      });
    },
    exportData() {
      if (!this.year) {
        this.$Message.error('请选择年份');
        return;
      }
      this.$api.setting.auditExport.export({ year: this.year }).then((res) => {
        this.downloadJson('audit_export_' + this.year + '.json', res.data);
        this.loadData();
      });
    },
    download(row) {
      this.downloadJson('audit_export_' + row.year + '.json', JSON.stringify(row));
    },
    downloadJson(filename, content) {
      const blob = new Blob([content], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.setting-page { padding: 16px; }
.panel { background: #fff; border-radius: 4px; padding: 16px; margin-bottom: 16px; }
.title { font-size: 16px; font-weight: bold; margin-bottom: 8px; }
.tip { color: #888; margin-bottom: 12px; }
.form-row { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.desc { margin-top: 16px; color: #555; line-height: 1.8; }
.desc .note { color: #999; font-size: 13px; }
.empty { text-align: center; color: #aaa; padding: 20px; }
</style>
